<template>
  <div class="washer">
    <div class="content c895">
      <h2>Dodajte pralni stroj</h2>
    </div>
    <div class="content c590">
      <div class="popup popDev2" :style="{display: !err ? 'none' : 'block'}">
        <div class="inner">
          <h3></h3>
          <div class="msg">
            <h3>Izpolniti je potrebno vsaj eno polje za pogostost uporabe naprave!</h3>
          </div>

          <div class="btns">
            <a class="btn" title="OK" @click="err = false">V REDU</a>
          </div>
        </div>
      </div>
      <div class="form">
        <h3>VPIŠITE PODATKE O PRALNEM STROJU</h3>
        <div class="f-item select">
          <label>
            Energijski razred:
            <span
              id
              style="color:Red;float:none;font-size:1em;"
              :style="{visibility: !err2 ? 'hidden' : 'visible'}"
            >*</span>
            <span>(oz. leto izdelave naprave)</span>
          </label>
          <select v-model="kategorija">
            <option value="0">Izberite</option>
            <option value="1">A+++ (-20%, po 2015)</option>
            <option value="2">A+++ (po 2015)</option>
            <option value="3">A++ (po 2015)</option>
            <option value="4">A+++ (po 2005)</option>
            <option value="5">A++ (po 2005)</option>
            <option value="6">A+ (po 2005)</option>
            <option value="7">A (po 2005)</option>
            <option value="8">B (2001-2004)</option>
            <option value="9">C (1999-2000)</option>
            <option value="10">D (1997-1998)</option>
            <option value="11">E (1995-1996)</option>
            <option value="12">F (1993 - 1994)</option>
          </select>
          <div class="help">
            <a href="#" class="help" title="Help">Help</a>
          </div>
        </div>
      </div>
      <div class="question">
        <p>
          Kolikokrat
          <b>na teden</b> perete, kdaj perete in na kateri temperaturi?
        </p>
        <div class="help">
          <a href="#" class="help" title="Help">Help</a>
        </div>
      </div>
      <div class="answer-list">
        <ul id>
          <li class="first">
            <div>PON-PET, 6:00-22:00</div>
            <div>PON-PET, 22:00-6:00 IN SOB-NED</div>
          </li>
          <li class="answer odd">
            <span>30°C</span>
            <div>
              <input v-model="teden3" type="text" id />
              <span>x</span>
            </div>
            <div class="last">
              <input v-model="vikend3" type="text" id />
              <span>x</span>
            </div>
          </li>
          <li class="answer">
            <span>40°C</span>
            <div>
              <input v-model="teden4" type="text" id />
              <span>x</span>
            </div>
            <div class="last">
              <input v-model="vikend4" type="text" id />
              <span>x</span>
            </div>
          </li>
          <li class="answer odd">
            <span>60°C</span>
            <div>
              <input v-model="teden6" type="text" id />
              <span>x</span>
            </div>
            <div class="last">
              <input v-model="vikend6" type="text" id />
              <span>x</span>
            </div>
          </li>
          <li class="answer">
            <span>95°C</span>
            <div>
              <input v-model="teden9" type="text" id />
              <span>x</span>
            </div>
            <div class="last">
              <input v-model="vikend9" type="text" id />
              <span>x</span>
            </div>
          </li>
        </ul>
      </div>
      <div class="add">
        <input type="submit" name value="Dodaj" @click="addedApplianceNum()" />
      </div>
    </div>
    <div class="content r-c">
      <div class="c282 info">
        <h3>INFO O PRALNEM STROJU</h3>
        <p>Glede na to, da praktično ne poznamo skupnih ali servisnih pralnic, je s pralnim strojem opremljeno skoraj vsako gospodinjstvo. Pralni stroji se razlikujejo tako po priključni moči, kot po porabi električne energije. Varčni pralni stroji porabijo tudi več kot 40 % manj električne energije in vode kot potratni. Seveda pa je varčevanje z vodo tudi varčevanje z energijo. Priključna moč pralnih strojev se giblje od 1,2 kW do 4 kW.</p>

        <div class="average">
          <h4>Povprečna poraba pralnega stroja za 4 člansko družino na leto</h4>
          <span>220 kWh/leto</span>
          <p>
            <strong>16,61 € / leto</strong> (enotarifno)
            <br />
            <strong>14,24 € / leto</strong> (dvotarifno)
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PralniStrojObj from '../classes/pralni_stroj';

export default {
  data: function () {
    return {
      kategorija: '',
      teden: [],
      teden3: null,
      teden4: null,
      teden6: null,
      teden9: null,
      vikend: [],
      vikend3: null,
      vikend4: null,
      vikend6: null,
      vikend9: null,
      err: false,
      err2: false,
    };
  },
  methods: {
    addedApplianceNum() {
      if (this.kategorija < 1) {
        this.err2 = true;
        return;
      }

      this.teden = [this.teden3, this.teden4, this.teden6, this.teden9];
      this.vikend = [this.vikend3, this.vikend4, this.vikend6, this.vikend9];

      var sum = this.teden.reduce(function (a, b) {
        return a + b;
      }, 0);
      sum += this.vikend.reduce(function (a, b) {
        return a + b;
      }, 0);

      if (sum < 1) {
        this.err = true;
        return;
      } else {
        this.err = false;
      }

      const PS = new PralniStrojObj(this.kategorija, this.teden, this.vikend);
      console.log('From washer');
      this.$emit('applianceFormClicked', PS);
    },
  },
};
</script>

<style>
</style>